<template>
  <v-new-dialog
    v-model="isShow"
    :title="rewardType==2?'Old Client Reward Setting':'Reward Settings'"
    @cancel="handleCancel"
    @next="handleConfrim" >
    <div class="dialog-content">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div class="form-item">
          <span>Insurer</span>
          <el-form-item
            ref="company_id"
            :rules="rules.select"
            prop="company_id">
            <v-select
              v-model="formData.company_id"
              :list="insurerOptions"
              :disabled="isEdit"
              @change="changeCompany"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Product Type</span>
          <el-form-item
            ref="class_id"
            :rules="rules.select"
            prop="class_id">
            <v-select
              v-model="formData.class_id"
              :list="productList"
              :disabled="isEdit"
              @change="getRewardData"
            ></v-select>

          </el-form-item>
        </div>
        <template v-if="plan_list.length > 0">
          <div
            class="form-item">
            <span>Plan Name</span>
            <el-form-item
              :rules="rules.select"
              prop="plan_id">
              <v-select
                v-model="formData.plan_id"
                placeholder="Select"
                :disabled="isEdit"
                :list="plan_list"
                @change="getRewardData"></v-select>
            </el-form-item>
          </div>
        </template>

        <div class="flex flex-sb-center">
          <div class="form-item mg-r-3">
            <span>Commission</span>
            <el-form-item
            >
              <v-input
                :value="commissionVaule"
                disabled
              />
            </el-form-item>
          </div>
          <div class="form-item mg-l-20">
            <span>{{rewardType==2?'Reward':'Referrer Reward'}}</span>
            <el-form-item
              ref="reward"
              prop="reward"
              :rules="rules.input"
            >
              <div class="flex flex-align-center">
                <v-input
                  :value="rewardVaule"
                  disabled
                />
                <font-awesome-icon
                  class="mg-lr-4"
                  icon="chevron-right"></font-awesome-icon>
                <v-input
                  v-model="formData.reward"
                  append="%"
                  key-number
                  int
                />
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </v-new-dialog>
</template>

<script>
import MixinRules from '@/mixins/rules'
import MixinOption from '@/mixins/options'
import {getAccountReferrerRewardData,setAccountReferrerReward,getInsurerPlanList} from '@api/account'

export default {
  name: 'reward-setting-dailog',
  mixins: [MixinRules,MixinOption],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    isEdit:{
      type:Boolean,
      default:false
    },
    rewardType:{
      type:Number,
      default:1
    },
    form:{
      type:Object,
      default:()=>({})
    },
    productInitList:{
      type:Array,
      default:()=>([])
    },
  },
  data(){
    return{
      isShow:false,
      formData:{
        company_id:'',
        user_id:'',
        plan_id:'',
        insurance_type:'',
        reward:0,
        class_id:0
      },
      productList:[],
      rewardData:{
        commission:0,
        reward_default:0
      },
    }
  },
  computed:{
    customerId() {
      return this.$route.query.customer_id
    },
    rewardVaule(){
      let {reward_default} = this.rewardData
      return reward_default||0
    },
    commissionVaule(){
      let {commission} = this.rewardData
      return commission||0
    },
    plan_list(){
      let {class_id} = this.formData||{}
      if(this.productList.length<=0)return []
      let data = this.productList.reduce((result, item)=>{
        if(item.id == class_id){
          let arr =[]
          if(item.plan_list)
            arr = Object.entries(item.plan_list).map(([value, label]) => ({
              name:label,
              id: Number(value)
            }))
          result = arr
        }
        return result
      },[])
      return data||[]
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
        if(val){
          if(this.isEdit){
            this.init()
          }else {
            this.formData.plan_id = 0
            this.formData.class_id =0
            this.formData.company_id = 0
            this.formData.reward = 0
            this.rewardData = {
              commission:0,
              reward_default:0
            }
            this.$nextTick(()=>{
              if(this.$refs.form)
                this.$refs.form.resetFields()
            })
          }
        }
      }
    },
    isShow:{
      immediate:true,
      handler(val){
        this.$emit('input',val)
      }
    },
    productInitList:{
      immediate:true,
      handler(val){
        this.productList = val||[]
      }
    },
  },
  methods:{
    init(){
      let {class_id=0,plan_id=0,company_id=0,reward=0,reward_default=0,commission=0 } = this.form||{}
      this.formData.plan_id = plan_id||0
      this.formData.class_id = class_id||0
      this.formData.company_id = company_id||0
      this.formData.reward = reward||0
      console.log('----s')
      this.rewardData = {
        commission,
        reward_default
      }
      // this.$nextTick(()=>{
      //   this.network().getInsurerPlanList()
      // })
    },
    handleCancel(){
      this.rewardData = {
        commission:0,
        reward_default:0
      }
      this.$refs.form.resetFields()
    },
    handleConfrim(){
      this.$refs.form.validate(valid => {
        if(valid) {
          this.network().setAccountReferrerReward()
        }
      })
    },
    async changeCompany(){
      await this.network().getInsurerPlanList()
      this.getRewardData()

    },
    getRewardData(){
      let {plan_id,company_id,class_id} = this.formData
      if(!class_id||!company_id)return
      this.network().getAccountReferrerRewardData({reward_type:this.rewardType,class_id,plan_id:plan_id||0,company_id})
    },
    network() {
      return {
        getInsurerPlanList: async params => {
          params={
            company_id: this.formData.company_id,
            hideLoading:true
          }
          const {data} = await getInsurerPlanList(params)
          this.productList = data
        },
        getAccountReferrerRewardData: async params => {
          const {data} = await getAccountReferrerRewardData({...params,user_id:this.customerId,hideLoading:true})
          this.rewardData = data.data
        },
        setAccountReferrerReward: async params => {
          let {plan_id} = this.formData
          params = {
            ...params,
            ...this.formData,
            plan_id:plan_id||0,
            reward_type:this.rewardType,
          }
          if(this.isEdit){
            params.id = this.form.id
          }
          const {data} = await setAccountReferrerReward({...params,user_id:this.customerId})
          this.rewardData = {
            commission:0,
            reward:0,
          }
          this.$emit('update')
          this.$refs.form.resetFields()
          this.$emit('input',false)

        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .mg-lr-4{
    margin: 0 4px;
  }
  /deep/.el-cascader{
    width: 100%;
    .el-input{
      height: 32px;
    }
  }
</style>
